import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconHeart } from '../../../../../assets/icons';
import { Tabs, TabType } from '../../../../../components';
import { DASHBOARD_METER_GROUP } from '../../../../../const';
import { UserGroup, UserPermissionType } from '../../../../../data-access/gql-types/graphql';
import { useUserPermissions } from '../../../../../hooks/user/use-user-permissions';
import { ROUTES } from '../../../../../routes/routes';
import { availableGroupIcons } from '../../../../../utils/available-icons';
import { useGroups } from '../../../hooks/groups/use-groups';

type GroupTabsProps = {
  activeTabIndex: number;
  setActiveTabIndex: (value: number) => void;
  biggerTabs?: boolean;
};

export const GroupTabs: React.FC<GroupTabsProps> = ({ activeTabIndex, setActiveTabIndex, biggerTabs }) => {
  const navigate = useNavigate();
  const { permissions } = useUserPermissions();
  const { groups, groupsLoading } = useGroups();
  const canCreateGroup = permissions[UserPermissionType.GroupCreate];

  const tabs = useMemo(() => {
    if (groupsLoading) return [];

    const items = groups
      .filter((x) => x.group.name !== DASHBOARD_METER_GROUP)
      ?.map(
        ({ group }: UserGroup) =>
          ({
            label: group.name,
            ...(group.isDefaultGroup
              ? { icon: <IconHeart /> }
              : { icon: availableGroupIcons.find((x) => x.iconName === group.iconName)?.component }),
          } as TabType),
      );

    return canCreateGroup
      ? [...items, { label: '+', onClick: () => navigate(ROUTES.GroupCreate()), addNew: true }]
      : [...items];
  }, [groups, groupsLoading, canCreateGroup]);

  return (
    <Tabs
      tabList={tabs}
      activeTabIndex={activeTabIndex}
      setActiveTabIndex={setActiveTabIndex}
      tabsType="pills"
      isDivider={false}
      biggerTabs={biggerTabs}
      moreButton="normal"
    />
  );
};
